{
  "uplift": {
    "header": "L'offre de prêt que vous avez reçue d’Uplift a expiré",
    "nextSteps": "Vous avez récemment reçu une offre de prêt d'Uplift, qui a maintenant expiré. Si vous avez modifié les détails de votre commande ou si vous pensez qu'il s'agit d'une erreur, veuillez vous adresser à votre agent pour connaître les prochaines étapes.",
    "thanks": "Si vous avez déjà payé en utilisant un autre mode de paiement, nous vous remercions de votre intérêt et espérons que vous envisagerez d'utiliser Uplift à l'avenir."
  },
  "flexpay": {
    "header": "L'offre de prêt que vous avez reçue de Flex Pay a expiré",
    "nextSteps": "L’offre de prêt que vous avez récemment reçue de Flex Pay a expiré. Si des modifications ont été apportées aux détails de votre commande ou si vous pensez qu'il s'agit d'une erreur, veuillez vous adresser à votre agent pour connaître les prochaines étapes.",
    "thanks": "Si vous avez déjà payé votre commande en utilisant un autre mode de paiement, nous vous remercions de votre intérêt et espérons que vous envisagerez d'utiliser Flex Pay à l'avenir."
  }
}
